import { useEffect } from 'react';
import Accordion from 'src/components/atoms/Accordion';
import {
  useAction,
  useLabels,
  useLanguageStore,
  useSitemapStore,
} from 'src/StoreDataProvider';
import AccordionContentSitemapCountry from '../AccordionSitemapCountry';

const AccordionSitemapEvaluation: () => JSX.Element = () => {
  const { getSitemap, getReportStartYearAndEndYear } = useAction();
  const { language } = useLanguageStore();
  const sitemapStore = useSitemapStore();
  const labels = useLabels();

  useEffect(() => {
    getSitemap(getReportStartYearAndEndYear(), language);
  }, [language]);

  return (
    <Accordion
      title={labels.projects.charAt(0).toUpperCase() + labels.projects.slice(1)}
      isActive={false}
      hierachy={3}
    >
      <ul>
        {sitemapStore?.items !== null && sitemapStore.items.length > 0 ? (
          sitemapStore.items.map((sitemapCountry, pos) => {
            return (
              <li
                className={`sitemap-container__list--country  ${
                  pos === sitemapStore.items.length - 1 ? 'last-item' : ''
                }`}
                key={`sitemap-container__list--country-${sitemapCountry.country}`}
              >
                <AccordionContentSitemapCountry
                  sitemapCountry={sitemapCountry}
                ></AccordionContentSitemapCountry>
              </li>
            );
          })
        ) : (
          <li
            className="sitemap-container__list--no-items"
            key="sitemap-container__list--no-items"
          >
            <div>{labels.projectsLoadingFailure}</div>
          </li>
        )}
      </ul>
    </Accordion>
  );
};

export default AccordionSitemapEvaluation;
